module.exports = __webpack_public_path__ + "static/media/icon-master-24px.6082511b.svg";